import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { useClient } from "@/context/ClientContext";

/** Single source of truth for dispositions — the Settings dropdown catalogue
 *  (lead_dropdowns key='disposition'). `options` = active only (what agents may
 *  pick); `byValue` covers inactive entries too so historical leads still render
 *  with their label and colour. Each option carries its `ownership_group`. */
export function useDispositions() {
  const { activeSlug } = useClient();
  const [all, setAll] = useState([]);

  useEffect(() => {
    let alive = true;
    api.get("/lead-dropdowns", { params: { key: "disposition" } })
      .then((r) => { if (alive) setAll(r.data.items || []); })
      .catch(() => {});
    return () => { alive = false; };
  }, [activeSlug]);

  const options = useMemo(() => all.filter((o) => o.active !== false), [all]);
  const byValue = useMemo(
    () => Object.fromEntries(all.map((o) => [o.value, o])),
    [all],
  );
  return { options, byValue, all };
}
